import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('article', 'articles');
const customActions = {
  async LOAD_articles({ commit }) {
    const data = await this.$o.client()
      .get('articles')
      .query({
        $filter: 'isActive eq true AND isDeleted eq false',
        $top: 50,
        $orderBy: 'created desc',
      });
    commit('SET_articles', data);
    return data;
  },
  async subscribeToArticles({ rootGetters }, token) {
    await odata.o(rootGetters)
      .post('subscribeToArticles', { token })
      .query();
  },
  async unsubscribeFromArticles({ rootGetters }, token) {
    await odata.o(rootGetters)
      .post('unsubscribeFromArticles', { token })
      .query();
  },
};

export default { ...actions, ...customActions };
